export class CandidatesQueryFilter {
    constructor(companyId, userId) {
        this.parentCompanyId = companyId;
        this.loggedInUserId = userId;
        this.status = [];
        this.roleList = [];
        this.recruiterList = [];
        this.vendors = [];
        this.requisitionNumbers = [];
        this.clientOrBuList = [];
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.phone = "";
        this.requisitionStatus = [];
        this.workflowStates = [];
        this.workLocationIds = [];
        this.visibility = [];
        this.searchString = "";
        this.pageSize = 12;
        this.pageNum = "";
        this.candidateType = "OWN_CANDIDATES";
        this.jobTypes = [];
        this.jobSubTypes = [];
        this.sponsorships = [];
        this.includeWithoutCompensation = true;
        this.salary = null;
        this.salaryDuration = "PER_YEAR";
        this.rate = null;
        this.rateDuration = "PER_HOUR";
        this.currency = "USD";
        // the below properties cannot be empty and should be added as per requirement
        //this.column;
        //this.sortDirection;
    }
}
//# sourceMappingURL=candidatesQueryFilter.js.map